import React from 'react';
import { MoreBtn } from '@/components'
import { Link } from 'react-router-dom'

class news extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      productImages: [
        {
          imgPath: require("img/pic1.png"),
          imgHDPath: `${require("img/pic1.png")} 1x,${require("img/pic1@2x.png")} 2x,${require("img/pic1@3x.png")} 3x`,
          title: '工程设计',
          desc: '聚焦自然美学，遵循可持续发展理念，将文化与自然融入设计；基于整体设计以及创新意识，打破学科界限，通过多专业协同为客户提供富于创造性的整体环境解决方案。',
          link: '/Products/ProductDetails/EngineeringDesign'
        },
        {
          imgPath: require("img/pic2.png"),
          imgHDPath: `${require("img/pic2.png")} 1x,${require("img/pic2@2x.png")} 2x,${require("img/pic2@3x.png")} 3x`,
          title: '采购与招标代理',
          desc: '专注工程建设项目招标代理和政府采购项目采购代理，依托最新颁布实施的法律法规，遵循规范的全流程管控制度 ，借鉴丰富的实操经验，将招标采购风险防患于未然。',
          link: '/Products/ProductDetails/Tendering'
        },
        {
          imgPath: require("img/pic3.png"),
          imgHDPath: `${require("img/pic3.png")} 1x,${require("img/pic3@2x.png")} 2x,${require("img/pic3@3x.png")} 3x`,
          title: '工程造价咨询',
          desc: '凸显“动态监控”特色，通过全过程造价管理系统、标准化工程计量、BIM技术支持，提升投资管控效率与效果，造价管理更轻松、更透明，更准确。',
          link: '/Products/ProductDetails/Cost'
        },
      ],
    }
  }
  render() {
    return (
      <section className="products">
        <h4 className="title">
          <Link to="/Products/ProductDetails/WholeProcess">全过程工程咨询产品服务线</Link>
        </h4>
        <ul>
          {
            this.state.productImages.map((item, index) =>
              <li key={index}>
                <Link to={item.link}>
                  <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" />
                  <div>
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </Link>
              </li>
            )
          }
        </ul>
        <div style={{ padding: '19px 0 25px' }}>
          <MoreBtn link={'/Products/ProductDetails/WholeProcess'}/>
        </div>
      </section>
    );
  }
}

export default news;
